module.exports = __webpack_public_path__ + "static/img/commitment-6_light.0f5dda86.png";